export default __webpack_public_path__ + "static/media/Eye_4_M_C3.19d8d297.svg";